module.exports = __webpack_public_path__ + "img/mv6.d06fb957.png";